// extracted by mini-css-extract-plugin
export default {"root":"CaseDetailsInfo_root__GEp44"};